import { createSlice } from '@reduxjs/toolkit';
import { Manufacturer } from '../types/manufacturer';
import { Pagination } from '../types/pagination';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getManufacturersApi, createManufacturersApi, updateManufacturersApi } from '../services/manufacturers/manufacturers';
import { createQuery } from '../utils/constants';

interface InitialState {
  variant: string | null;
  message: string | null;
}

interface Filter {
  limit: number | null;
}

const initialState: InitialState = {
  message: '',
  variant: '',
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<any>) => {
      state.message = action.payload.message;
      state.variant = action.payload.variant;
    },
  },
});

export const { setMessage } = commonSlice.actions;
export default commonSlice.reducer;

export const setAlert = (message: string, variant?: string) => async (dispatch: any, getState: any) => {
  return dispatch(setMessage({ message: message, variant: variant }));
};
